import { Tooltip } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import styles from './index.module.css';

const DetailItem = (props: any) => {
    const nodeRef: any = useRef()
    const [overflowStatus, setOverflowStatus] = useState(false)
    const overflowHandle = () => {
        const node = nodeRef.current
        const clientWidth = node.clientWidth
        const scrollWidth = node.scrollWidth
        if (clientWidth < scrollWidth) {
            setOverflowStatus(true)
        } else {
            setOverflowStatus(false)
        }
    }
    useEffect(() => {
        overflowHandle()
        const handler = () => {
            overflowHandle()
        }
        window.addEventListener('resize', handler)
        return () => {
            window.removeEventListener('resize', handler);
        }
    }, [])


    return (
        <div className={styles['detail-item-wrap']}>
            <div className={styles['detail-label']}>{props.label}</div>
            {overflowStatus && <Tooltip placement="top" title={props.value}>
                <div ref={nodeRef} className={styles['detail-content']}>
                    {props.value}
                    <div className={styles['detail-icon']}>
                        {props.children}
                    </div>
                </div>
            </Tooltip>}
            {!overflowStatus && <div ref={nodeRef} className={styles['detail-content']}>
                {props.value}
                <div className={styles['detail-icon']}>
                    {props.children}
                </div>
            </div>}
        </div>
    )
}

export default DetailItem;

